import * as Noodl from "@noodl/noodl-sdk";
import { avatarNode } from "./reactNodes/avatar";
// module
Noodl.defineModule({
    reactNodes: [avatarNode],
    nodes: [],
    settings: [],
    setup() { },
});
